export default __webpack_public_path__ + "static/media/hamburger.4460fecd.svg";